import Autocomplete from '@trevoreyre/autocomplete-js/dist/autocomplete.esm';

class Swiftype {
	constructor(node, opts = {} ) {
		this.node = node;
		this.opts = Object.assign( {}, opts );

		if ( ! this.node ) {
			return;
		}

		this.filters = {
			page: {}
		};

		if ( this.opts.domain ) {
			this.filters.page.domain = [ this.opts.domain ];
		}

		this.input = this.node.querySelector('input[name="s"]');

		if ( ! this.input ) {
			return;
		}

		this.input.classList.add('autocomplete-input');
		this.node.insertAdjacentHTML( 'beforeend', '<ul class="autocomplete-result-list"></ul>')

		this.autocomplete = new Autocomplete( this.node, {
			debounceTime: 300,
			search: ( query ) => {
				if ( query.length <= 2 ) {
					return [];
				}

				return new Promise( ( resolve, reject ) => {
					window.fetch( `https://search-api.swiftype.com/api/v1/public/engines/suggest.json?engine_key=${this.opts.engineKey}&q=${query}`, {
						method: 'POST',
						mode: 'cors',
						headers: { 'Content-Type': 'application/json' },
						body: JSON.stringify({ filters: this.filters })
					} ).then( response => response.json() ).then( response => {
						return resolve(response.records.page);
					} ).catch((err) => {
						return reject(err);
					} );
				} );
			},
			getResultValue: ( result ) => result.title,
			renderResult: ( result, props ) => `
				<li ${props}>
					${result.highlight.title || result.title}
				</li>
			`,
			onSubmit: (result) => {
				if ( result && result.url ) {
					window.location.href = result.url;
				}
			}
		} );
	}
}

export default function( selector = 'form[data-swiftype]', opts = {} ) {
	const nodes = Array.from( document.querySelectorAll( selector ) );

	if ( ! opts.engineKey ) {
		let engineKeyMeta = document.head.querySelector('meta[name="swiftype-engine-key"]');

		if ( engineKeyMeta ) {
			opts.engineKey = engineKeyMeta.getAttribute('content');
		}
	}

	if ( ! opts.domain ) {
		let domainMeta = document.head.querySelector('meta[name="domain"]');

		if ( domainMeta ) {
			opts.domain = domainMeta.getAttribute('content');
		}
	}

	return nodes.map( node => new Swiftype(node, opts) );
}
